import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { projectsColumn } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { changeProjectSearch, getAllProjectCustomerList } from "Stores/actions";
import { read, store } from "Helpers/LocalStorage";
import Translator from "Languages/Utility/Translator";
import { ReactSVG } from "react-svg";
import moreIcon from "Assets/svg/icon/more.svg";
import minusIcon from "Assets/svg/icon/minus.svg";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import HistoryState from "../HistoryState";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import * as Icons from "react-bootstrap-icons";

function ProjectsTable({ onSelect }) {
  const {
    projectsList,
    projectsListPagination,
    selectedProject,
    selectedUser,
    projectDataSearch,
    selectedCustomer,
    selectedCustomerAdmin,
    rtlLayout,
  } = useSelector((state) => ({
    projectsList: state.project.projectsList,
    projectsListPagination: state.project.projectsListPagination,
    selectedProject: state.project.selectedProject,
    selectedUser: state.project.selectedUser,
    projectDataSearch: state.project.projectDataSearch,
    selectedCustomer: state.project.selectedCustomer,
    selectedCustomerAdmin: state.project.selectedCustomerAdmin,
    rtlLayout: state.settings.rtlLayout,
  }));
  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(projectsListPagination?.Limit);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(projectsListPagination?.Page);
  const [total, setTotal] = useState(1);
  const [selectRow, setSelectRow] = useState({
    mode: "radio",
    clickToSelect: false,
    selectionHeaderRenderer: () => (
      <div className="select-project-header-button">
        <Translator id="selectProjectTable" />
      </div>
    ),
    onSelect: (row) => onSelect(row),
    classes: "selection-row button",
    selectionRenderer: ({ checked, disabled }) => {
      return (
        <MuiIconButton
          className={`primary-button-select-project${checked ? " selected" : ""}`}
          icon={
            checked ? <Icons.Check2 size={17} /> : <Icons.Circle size={17} />
          }
          title={<Translator id="selectProject" />}
          disabled={disabled}
        />
      );
    },
  });
  const [tblData, setTblData] = useState(projectsList);
  let updateProjectsColumn = [...projectsColumn];
  updateProjectsColumn[5].hidden =
    read("StypeU") === "1" || read("StypeU") === "5";
  // updateProjectsColumn[8].hidden = (!read("contractRules"));
  // updateProjectsColumn[9].hidden = (!read("constructCutList") || !read("constructGlass"));

  useEffect(() => {
    if (projectsList) {
      setTblData(projectsList);
      setTotal(projectsListPagination?.Total);
      setCurrentPage(projectsListPagination?.Page);
      setSizePerPage(projectsListPagination?.Limit);
    }
  }, [projectsList, projectsListPagination]);

  useEffect(() => {
    if (selectedProject) {
      const selectRows = {
        mode: "radio",
        clickToSelect: false,
        selectionHeaderRenderer: () => (
          <div className="select-project-header-button">
            <Translator id="selectProjectTable" />
          </div>
        ),
        onSelect: (row) => {
          onSelect(row);
          //isLockProject
          store("isLockProject", row.IsLock);
        },
        classes: "selection-row",
        selected: [selectedProject?.Id],
        selectionRenderer: ({ checked, disabled }) => {
          return (
            <MuiIconButton
              className={`primary-button-select-project${checked ? " selected" : ""}`}
              icon={
                checked ? (
                  <Icons.CheckCircleFill size={17} />
                ) : (
                  <Icons.Circle size={17} />
                )
              }
              title={
                <Translator
                  id={!checked ? "selectProject" : "selectedProject"}
                />
              }
              disabled={disabled}
            />
          );
        },
      };
      setSelectRow(selectRows);
    }
  }, [selectedProject]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      try {
        setLoading(true);
        if (
          (read("StypeU") === "1" || read("StypeU") === "5") &&
          read("UserC") === "-"
        ) {
          const paramsList = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            KeyRequestUser: selectedUser.Key,
            Name: projectDataSearch?.Name,
            IdCustomer: selectedCustomerAdmin.value,
            IdProject: 0,
            Limit: sizePerPage,
            Page: page,
          };
          dispatch(
            changeProjectSearch({ ...projectDataSearch, pagination: page }),
          );
          store("lsProjectDataSearch", {
            ...projectDataSearch,
            pagination: page,
          });
          await dispatch(getAllProjectCustomerList(paramsList));
          setCurrentPage(page);
          setSizePerPage(sizePerPage);
        } else if (read("StypeU") === "2" || read("UserC") === "zero") {
          const paramsList = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdCustomer: selectedCustomer.Id,
            Name: projectDataSearch?.Name,
            IdProject: 0,
            Limit: sizePerPage,
            Page: page,
          };
          await dispatch(getAllProjectCustomerList(paramsList));
          setCurrentPage(page);
          setSizePerPage(sizePerPage);
        }
        setLoading(false);
      } catch (e) {
        console.log("Projects Table Error:", e);
        setLoading(false);
      }
    }
  };

  // useEffect(() => {
  //   if (read("StypeU") === "1" || read("StypeU") === "5") {
  //     if(selectedUser) setLoading(false);
  //     else setLoading(true);
  //   }
  // }, [selectedUser])

  const expandRow = {
    renderer: (row) => (
      <>
        <p>{<Translator id="statusHistory" />} </p>
        <HistoryState data={row.HistoryState} />
      </>
    ),
    showExpandColumn: true,
    expandColumnPosition: "right",
    expandHeaderColumnRenderer: () => null,
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <ReactSVG src={minusIcon} />;
      }
      return <ReactSVG src={moreIcon} />;
    },
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      <RemoteTable
        // sizePerPageList={[
        //   {
        //     text: "3",
        //     value: 3,
        //   },
        //   {
        //     text: "5",
        //     value: 5,
        //   },
        // ]}
        loading={loading}
        keyField="Id"
        selectRow={selectRow}
        data={tblData}
        columns={updateProjectsColumn}
        page={currentPage}
        sizePerPage={sizePerPage}
        totalSize={total}
        onTableChange={onTableChange}
        rowHeight="70px"
        // expandRow={expandRow}
      />
    </>
  );
}

export default ProjectsTable;
